module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"uploadImage":"Upload image"}}')
  delete Component.options._Ctor
}
